import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import TroubleshootingGuide from "./pages/TroubleshootingGuide";
import DefectPage from "./pages/DefectPage";
import KnowledgeCenter from "./pages/KnowledgeCenter";
import ArticlePage from "./pages/ArticlePage";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gravure-troubleshooting" element={<TroubleshootingGuide />} />
          <Route path="/gravure-troubleshooting/:slug" element={<DefectPage />} />
          <Route path="/knowledge-center" element={<KnowledgeCenter />} />
          <Route path="/knowledge-center/:slug" element={<ArticlePage />} />
        </Routes>
        {/* Global Floating WhatsApp Button */}
        <FloatingWhatsApp />
      </BrowserRouter>
    </div>
  );
}

export default App;
